import React, { FC } from 'react';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import css from '@styled-system/css';

import { Loader } from '../../icons/glyphs';
import { SpinnerProps } from './types';

const rotate360 = keyframes`
to {
  transform: rotate(360deg);
}
`;

const StyledLoaderIcon = styled(Loader)(
  css({
    animation: `${rotate360} 1s steps(360, end) infinite`,
  })
);

const Spinner: FC<SpinnerProps> = ({ size = 'xlarge', ...props }) => {
  return <StyledLoaderIcon {...props} size={size} color="primary.50" />;
};

export default Spinner;
